import { createFileRoute } from '@tanstack/react-router'
import { ROUTES } from '@/constants/routeConstants'
import { ContactPage } from '@/pages/ContactPage'

const ContactRoute = () => {
  return <ContactPage />
}

export const Route = createFileRoute(ROUTES.CONTACT_US)({
  component: ContactRoute,
})
